import { Entity, Field } from "typegraph";

import Entry from "./Entry";
import ProgramProgress from "./ProgramProgress";

@Entity({one: "program", many: "programs"})
export default class Program {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field({entity: ProgramProgress})
	public progress: ProgramProgress[];

	@Field({entity: Entry})
	public preTest?: Entry;

	@Field({entity: Entry})
	public postTest?: Entry;

}



// WEBPACK FOOTER //
// ./src/panels/programStatus/entities/Program.ts